import type {
  DownloadFileProps,
  DownloadFileWithNotifyProps,
} from "./file-downloader.type";

import { t } from "i18next";

export const downloadFileFromBlob = (blob: Blob, name: string) => {
  const tempUrl = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = tempUrl;
  a.download = name;

  a.click();
  a.remove();

  window.URL.revokeObjectURL(tempUrl);
};

export const downloadFileWithNotify = ({
  url,
  name,
  notify,
  onFinally,
}: DownloadFileWithNotifyProps) => {
  fetch(url)
    .then((resp) => resp.blob())
    .then((blob) => {
      downloadFileFromBlob(blob, name);
    })
    .catch(() => {
      notify.error({ title: t("global:downloadFailed") });
    })
    .finally(() => {
      onFinally?.();
    });
};

export const downloadFile = ({
  url,
  name,
  target = "_blank",
}: DownloadFileProps) => {
  if (!url) return;

  const a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("target", target);

  if (name) {
    a.setAttribute("download", name);
  }

  a.click();
  a.remove();
};
